import { render, staticRenderFns } from "./AddNewCilent.vue?vue&type=template&id=6c445d83&"
import script from "./AddNewCilent.vue?vue&type=script&lang=js&"
export * from "./AddNewCilent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports